var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0246 22.3559C14.7116 22.3559 18.5112 18.5563 18.5112 13.8694C18.5112 9.18236 14.7116 5.38281 10.0246 5.38281C5.33764 5.38281 1.53809 9.18236 1.53809 13.8694C1.53809 18.5563 5.33764 22.3559 10.0246 22.3559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1209 20.427L10.0133 20.2436C8.36907 17.4421 3.99974 11.497 3.95561 11.4373L3.89258 11.3517L5.38118 9.88053L10.0933 13.1709C13.0602 9.32091 15.8281 6.67659 17.6335 5.1324C19.6086 3.44322 20.8942 2.66558 20.9072 2.65813L20.9364 2.64062H23.4615L23.2203 2.85543C17.017 8.38072 10.2933 20.1242 10.2263 20.2422L10.1209 20.427Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkright);
export default __webpack_public_path__ + "static/media/checkmarkright.f385df88366dda71582668533f977b23.svg";
export { ForwardRef as ReactComponent };